import styled from 'styled-components';
import Typography from '@klv/atoms/typography';
import type { IQuoteText } from '../types';

export const QuoteFigure = styled.figure`
margin-bottom: 4.8rem;
`;

export const QuoteText = styled(Typography)<IQuoteText>`
  ${({ theme, $backgroundColor }) => `
    color: inherit;

    &:before {
      content: "“";
      display: block;
      margin-top: -.4rem;
      margin-bottom: .4rem;
      padding-top: 4.3rem;
      line-height: 0;
      font-size: 8rem;
      color: ${theme.quote[$backgroundColor].quoteMark};
      ${theme.fonts.recklessNeue.regular}
    }
    ${theme.screenSize.s1024.mediaQuery} {
      &:before {
        font-size: 10.8rem;
        margin-top: 3.2rem;
        margin-bottom: 0.8rem;
      }  
  `}
`;

export const Attribution = styled(Typography)`
  ${({ theme }) => `
    margin-top: 1.6rem;

    ${theme.screenSize.s1024.mediaQuery} {
      margin-top 2.7rem;
    }
  `}
`;
